import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {        
        const currentLanguage = i18n.language; // Détermine la langue actuelle
        const newLanguage = currentLanguage === 'fr' ? 'en' : 'fr'; // Décide de la nouvelle langue : si c'est 'fr', passe à 'en' ; sinon, passe à 'fr'
        
        i18n.changeLanguage(newLanguage); // Change la langue
    };

    const currentLanguage = i18n.language === 'fr' ? 'English' : 'Français'; // Le texte du bouton change en fonction de la langue actuelle
    //const buttonLabel = i18n.language === 'fr' ? 'Switch to English 🇬🇧' : 'Passer au français 🇫🇷';

    return (
        <button
            type="button"
            className="btn btn-outline-secondary fw-bold fs-6 text-capitalize"
            onClick={toggleLanguage}>
            {currentLanguage}
        </button>
    );
};

export default LanguageSelector;

//import React from 'react';
//import { useTranslation } from 'react-i18next';

//const LanguageSelector = () => {
//    const { i18n } = useTranslation();

//    const changeLanguage = (event) => {
//        // i18n.changeLanguage met à jour l'état global et redessine l'appli
//        i18n.changeLanguage(event.target.value);
//    };

//    return (
//        <select value={i18n.language} onChange={changeLanguage}>
//            <option value="fr">Français</option>
//            <option value="en">English</option>
//        </select>
//    );
//};

//export default LanguageSelector;